import { composeClassNames } from "@faedev/editor-utils";
import { useState } from "react";
import { Button } from "react-bootstrap";
import Content from "src/components/Content";
import SectionHeading from "src/components/SectionHeading";
import Translate from "src/components/Translate";
import WhyToUseCompanies from "src/components/WhyToUseCompanies";
import WhyToUseInstructors from "src/components/WhyToUseInstructors";
import WhyToUseYogis from "src/components/WhyToUseYogis";
import constants from "src/constants";
import { sButton } from "src/styles/sButton.module.scss";
import { sWhyToUse } from "src/styles/sWhyToUse.module.scss";

type Props = {
  backgroundColor?: string | null | undefined;
  className?: (string | string) | null | undefined;
  specificContent: "members" | "instructors" | "companies" | "none";
  subtitle: string;
  title: string;
};

function WhyToUse({
  backgroundColor,
  className,
  specificContent,
  subtitle,
  title,
}: Props) {
  const [activeContent, setActiveContent] = useState<
    "members" | "instructors" | "companies"
  >(specificContent !== "none" ? specificContent : "members");

  return (
    <Content
      style={{ background: backgroundColor || constants.Theme.white }}
      className={composeClassNames([sWhyToUse, className, "whyToUse"])}
      fluid={`full`}
      verticalSpace={`lg`}
    >
      <div
        className={composeClassNames([
          "whyToUse-wrapper",
          specificContent === "members" && "specificContent",
        ])}
      >
        <SectionHeading align="center" subtitle={subtitle} title={title} />
        {specificContent === "none" && (
          <div className="whyToUse-switch-wrapper">
            <div className="whyToUse-switch">
              <Button
                variant="outline-primary"
                size="sm"
                className={composeClassNames([
                  sButton,
                  `switch-button`,
                  activeContent === "members" ? "active" : null,
                ])}
                onClick={() => setActiveContent("members")}
              >
                <Translate tKey={`Yogis`} />
              </Button>
              <Button
                variant="outline-primary"
                size="sm"
                className={composeClassNames([
                  sButton,
                  `switch-button`,
                  activeContent === "instructors" ? "active" : null,
                ])}
                onClick={() => setActiveContent("instructors")}
              >
                <Translate tKey={`Instructors`} />
              </Button>
              {constants.Show.homepageWhyToUseCompanies && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className={composeClassNames([
                    sButton,
                    `switch-button`,
                    activeContent === "companies" ? "active" : null,
                  ])}
                  onClick={() => setActiveContent("companies")}
                >
                  <Translate tKey={`Companies`} />
                </Button>
              )}
            </div>
          </div>
        )}
        {activeContent === "members" && (
          <WhyToUseYogis specificContent={specificContent ? true : false} />
        )}
        {activeContent === "instructors" && (
          <WhyToUseInstructors
            specificContent={specificContent ? true : false}
          />
        )}
        {activeContent === "companies" && (
          <WhyToUseCompanies specificContent={specificContent ? true : false} />
        )}
      </div>
    </Content>
  );
}

export default WhyToUse;
